import type { ReactNode } from 'react'

export function DashboardPageHeader({
  title,
  subtitle,
  icon,
  actions,
  actionLayout,
}: {
  title: string
  /** Sin él, sólo el título (un aviso de error ya trae su explicación debajo). */
  subtitle?: string | undefined
  /** Ilustración a la izquierda del título. Decorativa: el texto ya lo dice. */
  icon?: string | undefined
  actions?: ReactNode
  /** Una fila completa: herramientas a la izquierda y el uso del plan a la derecha. */
  actionLayout?: 'split' | undefined
}) {
  return (
    <header className={`dash-page-header${actionLayout === 'split' ? ' dash-page-header--split-actions' : ''}`}>
      {/* Icono y texto van juntos en un bloque. Sueltos, el `space-between` del
          encabezado los mandaba a extremos opuestos y el título acababa en
          mitad de la página. */}
      <div className="dash-page-header-lead">
        {icon ? <img className="dash-page-header-icon" src={icon} alt="" /> : null}
        <div className="dash-page-header-copy">
          <h1>{title}</h1>
          {subtitle ? <p>{subtitle}</p> : null}
        </div>
      </div>
      {actions ? <div className={`dash-page-header-actions${actionLayout === 'split' ? ' dash-page-header-actions--split' : ''}`}>{actions}</div> : null}
    </header>
  )
}
